import * as v from 'valibot';
import { t } from 'i18next';

export const WarehouseFormSchema = v.object({
	title: v.pipe(
		v.string(t('Prosím nenechávejte toto pole prázdné.')),
		v.nonEmpty(t('Prosím nenechávejte toto pole prázdné.')),
	),
	street: v.pipe(
		v.string(t('Prosím nenechávejte toto pole prázdné.')),
		v.nonEmpty(t('Prosím nenechávejte toto pole prázdné.')),
	),
	streetNumber: v.nullable(v.string()),
	city: v.pipe(
		v.string(t('Prosím nenechávejte toto pole prázdné.')),
		v.nonEmpty(t('Prosím nenechávejte toto pole prázdné.')),
	),
	zip: v.nullable(v.string()),
});
